import '.df{display:inline-flex;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.ar{height:40px;}.ssr-plugin'
import '.e2{padding:8px;}.ssr-plugin'
import '.el{width:360px;}.ssr-plugin'
import '.fo{transition-timing-function:ease-in-out;}.ssr-plugin'
import '.bg{overflow:hidden;}.ssr-plugin'
import '.be{position:fixed;}.ssr-plugin'
import '.a0{position:relative;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.af{gap:4px;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.z{flex:1;}.ssr-plugin'
import '.de{outline:none;}.ssr-plugin'
import '.p{border:none;}.ssr-plugin'
import '.o{background:transparent;}.ssr-plugin'
import '.ip{font-size:14px;}.ssr-plugin'
import '.iq{font-weight:400;}.ssr-plugin'
import '.a1{height:100%;}.ssr-plugin'
import '.fq{padding:0 8px;}.ssr-plugin'
import '.ir{margin:0 4px;}.ssr-plugin'
import '.is{width:1px;}.ssr-plugin'
import '.b1{height:16px;}.ssr-plugin'
import { LinkNode } from '@lexical/link'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { mergeRegister } from '@lexical/utils'
import { $getSelection, $isRangeSelection, $setSelection } from 'lexical'
import { useEffect, useState } from 'react'
import { colors } from '../../../tokens/colors.js'
import { shadows } from '../../../utils/shadows.js'
import { radius } from '../../../utils/radius.js'
import { IconButton } from '../../IconButton/index.js'
import { useToast } from '../../Toast/index.js'
import { styled } from 'inlines'

function FloatingLinkPlugin() {
  const [editor] = useLexicalComposerContext()
  const [open, setOpen] = useState(false)
  const [prevValue, setPrevValue] = useState<string>()
  const [value, setValue] = useState<string>()
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const toast = useToast()

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        setOpen(false)
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [value, prevValue])

  useEffect(() => {
    return mergeRegister(
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          const selection = $getSelection()

          if (!$isRangeSelection(selection)) return

          const root = editor.getRootElement()
          const anchor = selection.anchor.getNode()
          const anchorParent = anchor.getParent()
          const native = window.getSelection()

          const node =
            anchor instanceof LinkNode
              ? anchor
              : anchorParent instanceof LinkNode
                ? anchorParent
                : null

          if (node && root.contains(native.anchorNode)) {
            const rect = native.focusNode.parentElement.getBoundingClientRect()
            const x = rect.left
            const y = rect.top

            setPosition({ x, y: y + rect.height + 8 })
            setValue(node.__url)
            setPrevValue(node.__url)
            setOpen(true)

            return
          }

          setOpen(false)
          setValue('')
          setPrevValue('')
        })
      }),
    )
  }, [editor, value])

  return (
    <>
      {open && (
        <div className="df b ar e2 el fo bg be"
          style={{
            background: colors.neutralInverted100,
            border: `1px solid  ${colors.neutral20Adjusted}`,
            boxShadow: shadows.popoverSmall,
            borderRadius: radius[16],
            left: position.x,
            top: position.y,
          }}
        >
          <div className="a0 df c b af h"
          >
            <input className="z de p o ip iq h a1 fq"
              // autoFocus={!value?.length}
              value={value}
              onChange={(e) => {
                setValue(e.target.value)
              }}
              placeholder="Add link"
              style={{
                color: colors.neutral80,
              }}
            />
            {value === prevValue ? (
              <>
                {value && (
                  <>
                    <IconButton
                      size="small"
                      icon="arrow-out"
                      tooltip="Open in new tab"
                      onClick={() => {
                        const val = value.includes('http')
                          ? value
                          : 'https://' + value

                        window.open(val, '_blank', 'noopener,noreferrer')
                        editor.update(() => {
                          $setSelection(null)
                        })
                        setOpen(false)
                      }}
                    />
                    <IconButton
                      size="small"
                      icon="copy"
                      tooltip="Copy link"
                      onClick={() => {
                        navigator.clipboard.writeText(value)
                        toast('Link copied', { icon: 'copy' })
                        editor.update(() => {
                          $setSelection(null)
                        })
                        setOpen(false)
                      }}
                    />
                  </>
                )}
                <div className="ir is b1"
                  style={{
                    background: colors.neutral20Adjusted,
                  }}
                />
                <IconButton
                  size="small"
                  icon="link-off"
                  tooltip="Remove link"
                  onClick={() => {
                    editor.update(() => {
                      const selection = $getSelection()
                      if (!$isRangeSelection(selection)) return

                      const nodes = selection.extract()
                      nodes.forEach((node) => {
                        const parent = node.getParent()
                        if (parent instanceof LinkNode) {
                          const children = parent.getChildren()
                          for (let i = 0; i < children.length; i++) {
                            parent.insertBefore(children[i])
                          }
                          parent.remove()
                        }
                      })
                    })
                  }}
                />
              </>
            ) : (
              <>
                <IconButton
                  size="small"
                  icon="checkmark-normal"
                  tooltip="Save changes"
                  keyHint="Enter"
                  onClick={() => {
                    editor.update(
                      () => {
                        const selection = $getSelection()
                        if (!$isRangeSelection(selection)) return
                        const nodes = selection.extract()
                        nodes.forEach((node) => {
                          const parent = node.getParent()
                          if (parent instanceof LinkNode) {
                            parent.setURL(value)
                          }
                        })
                        nodes[nodes.length - 1].selectEnd()
                      },
                      {
                        onUpdate: () => {
                          setOpen(false)
                        },
                      },
                    )
                  }}
                />
                <IconButton
                  size="small"
                  icon="close"
                  tooltip="Discard changes"
                  keyHint="Esc"
                  keyHintVisualOnly
                  onClick={() => {
                    setOpen(false)
                  }}
                />
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export { FloatingLinkPlugin }
